import { useRouteError, isRouteErrorResponse, Link } from "react-router";
import { Button } from "@nosible/shared/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@nosible/shared/components/ui/card";
import { AlertTriangle } from "lucide-react";

export function ErrorBoundary() {
  const error = useRouteError();

  let errorMessage: string;
  let errorDetails: string | undefined;
  let statusCode: number | undefined;

  if (isRouteErrorResponse(error)) {
    statusCode = error.status;
    errorMessage = error.statusText || "An error occurred";
    errorDetails = error.data?.message;
  } else if (error instanceof Error) {
    errorMessage = error.message;
    errorDetails = error.stack;
  } else {
    errorMessage = "An unexpected error occurred";
  }

  return (
    <div className="flex h-screen items-center justify-center bg-obsidian p-6">
      <Card className="max-w-2xl w-full">
        <CardHeader>
          <div className="flex items-center gap-3">
            <AlertTriangle className="h-6 w-6 text-red-500" />
            <div>
              <CardTitle className="text-xl">
                {statusCode ? `Error ${statusCode}` : "Application Error"}
              </CardTitle>
              <CardDescription>{errorMessage}</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-4">
          {errorDetails && (
            <div className="bg-slate-core/50 p-4 rounded-lg border border-slate-core">
              <p className="text-xs text-chromium-mist font-mono whitespace-pre-wrap break-all">
                {errorDetails}
              </p>
            </div>
          )}
          <div className="flex gap-3">
            <Button asChild>
              <Link to="/">Go Home</Link>
            </Button>
            <Button variant="outline" onClick={() => window.location.reload()}>
              Reload Page
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
